import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function MostCommunitiesRecognized({ data }) {
  if (!data) {
    return null; // Correct return for better handling
  }

  const imageUrl = `${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data.image}`;
  
  return (
    <section className="most-communities-recognized">
      <Container>
        <div className="text-box">
          {data.image && (
            <img
              className="text-box-img"
              src={imageUrl}
              alt={data.title || 'Image'}
            />
          )}
          <div className="text-box-right">
            {data.title && <h2>{data.title}</h2>}
            {data.btn_link && data.btn_name && (
              <Link to={data.btn_link} title="Learn More">
                {data.btn_name}
              </Link>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
}

export default MostCommunitiesRecognized;